// extracted by mini-css-extract-plugin
module.exports = {"previousPrice":"product-price_previousPrice__9hfzX","price":"product-price_price__EYgqg","markedDown":"product-price_markedDown__YzFme","discount":"product-price_discount__uVcaw"};